'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.getSwapRequest = getSwapRequest;
exports.responseSwapRequest = responseSwapRequest;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GET_SWAP_REQUEST = 'redux-frontend/swapRequest/GET_SWAP_REQUEST';
var GET_SWAP_REQUEST_SUCCESS = 'redux-frontend/swapRequest/GET_SWAP_REQUEST_SUCCESS';
var GET_SWAP_REQUEST_FAIL = 'redux-frontend/swapRequest/GET_SWAP_REQUEST_FAIL';

var RESPOND_SWAP_REQUEST = 'redux-frontend/swapRequest/RESPOND_SWAP_REQUEST';
var RESPOND_SWAP_REQUEST_SUCCESS = 'redux-frontend/swapRequest/RESPOND_SWAP_REQUEST_SUCCESS';
var RESPOND_SWAP_REQUEST_FAIL = 'redux-frontend/swapRequest/RESPOND_SWAP_REQUEST_FAIL';

var initialState = {
  data: {},
  error: null,
  processing: false
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case GET_SWAP_REQUEST:
      return (0, _extends3.default)({}, state);
    case GET_SWAP_REQUEST_SUCCESS:
      return (0, _extends3.default)({}, state, {
        data: action.result
      });
    case GET_SWAP_REQUEST_FAIL:
      return (0, _extends3.default)({}, state, {
        error: action.error
      });
    case RESPOND_SWAP_REQUEST:
      return (0, _extends3.default)({}, state, {
        processing: true
      });
    case RESPOND_SWAP_REQUEST_SUCCESS:
      return (0, _extends3.default)({}, state, {
        processing: false
      });
    case RESPOND_SWAP_REQUEST_FAIL:
      return (0, _extends3.default)({}, state, {
        processing: false
      });
    default:
      return state;
  }
};

function getSwapRequest(id) {
  return {
    types: [GET_SWAP_REQUEST, GET_SWAP_REQUEST_SUCCESS, GET_SWAP_REQUEST_FAIL],
    promise: function promise(client) {
      return client.get('/swap-request/' + id);
    }
  };
}

function responseSwapRequest(id, status) {
  return {
    types: [RESPOND_SWAP_REQUEST, RESPOND_SWAP_REQUEST_SUCCESS, RESPOND_SWAP_REQUEST_FAIL],
    promise: function promise(client) {
      return client.put('/swap-request/' + id, { data: { status: status } });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/swapRequest.js
// module id = 685
// module chunks = 47